export enum EventVisibility {
  Organization = 'organization',
  Invitees = 'invitees',
}
